import {
	ADD_CSV_FAIL,
	ADD_CSV_START,
	ADD_CSV_SUCCESS,
	ADD_TAMPONI_CSV_FAIL,
	ADD_TAMPONI_CSV_START,
	ADD_TAMPONI_CSV_SUCCESS,
	CHECK_UPLOAD_FAIL,
	CHECK_UPLOAD_START,
	CHECK_UPLOAD_SUCCESS, SEND_CSV_FAIL, SEND_CSV_START, SEND_CSV_SUCCESS
} from "../reducers/actions/ActionTypes";
import axios from "axios";
import {
	ADD_GUARITI_CSV_URL,
	ADD_RAPIDI_CSV_URL,
	ADD_TAMPONI_CSV_URL, ADD_VACCINATI_URL, CHECK_STATUS_UPLOAD_URL, SEND_CSV_MAIL_URL
} from "./utils/ApiUrls";
import {getErrorMessage} from "../reducers/utils/ReducerUtils";
import {
	getSirvaCsv, getSmsMailData
} from "./utils/ApiData";
import {getConfig} from "./utils/ConfigUtils";
import moment from "moment";

export function addTamponi(data, dispatch) {
	dispatch({type: ADD_TAMPONI_CSV_START});
	axios
		.post(ADD_TAMPONI_CSV_URL, getSirvaCsv(data, "csv"), getConfig())
		.then((response) => {
			console.log(response);
			dispatch({type: ADD_TAMPONI_CSV_SUCCESS, payload: response.data})
		})
		.catch((error) => dispatch({type: ADD_TAMPONI_CSV_FAIL, error: getErrorMessage(error)}))
}

export function addGuariti(data, dispatch) {
	dispatch({type: ADD_TAMPONI_CSV_START});
	axios
		.post(ADD_GUARITI_CSV_URL, getSirvaCsv(data, "csv"), getConfig())
		.then((response) => {
			console.log(response);
			dispatch({type: ADD_TAMPONI_CSV_SUCCESS, payload: response.data})
		})
		.catch((error) => dispatch({type: ADD_TAMPONI_CSV_FAIL, error: getErrorMessage(error)}))
}

export function addRapidi(data, dispatch, tipoTampone = "Tampone Rapido a lettura facilitata (91.13.S)", dataTampone = new Date()) {
	dispatch({type: ADD_TAMPONI_CSV_START});
	axios
		.post(ADD_RAPIDI_CSV_URL + btoa(tipoTampone) + "/" + moment(dataTampone).format("DD-MM-YYYY"), getSirvaCsv(data, "csv"), getConfig())
		.then((response) => {
			console.log(response);
			dispatch({type: ADD_TAMPONI_CSV_SUCCESS, payload: response.data})
		})
		.catch((error) => dispatch({type: ADD_TAMPONI_CSV_FAIL, error: getErrorMessage(error)}))
}

export function addVaccinati(data, dispatch) {
	dispatch({type: ADD_CSV_START});
	axios
		.post(ADD_VACCINATI_URL, getSirvaCsv(data), getConfig())
		.then(() => dispatch({type: ADD_CSV_SUCCESS}))
		.catch((error) => dispatch({type: ADD_CSV_FAIL, error: getErrorMessage(error)}))
}

export function checkStatusUpload(id, dispatch) {
	dispatch({type: CHECK_UPLOAD_START});
	axios
		.get(CHECK_STATUS_UPLOAD_URL + id, getConfig())
		.then((response) => dispatch({type: CHECK_UPLOAD_SUCCESS, payload: response.data}))
		.catch((error) => dispatch({type: CHECK_UPLOAD_FAIL, error: getErrorMessage(error)}))
}

export function sendCSVMail(data, dispatch) {
	dispatch({type: SEND_CSV_START})
	axios
		.post(SEND_CSV_MAIL_URL, getSmsMailData(data), getConfig())
		.then((response) => {
			alert(
				"Rigettati per comunicazione negli ultimi 7gg: " + response.data["Rigettati per comunicazione inviata negli ultimi 7 giorni"].length + " \n\n" +
				"Totale mail inviate: " + response.data["Totale mail inviate"] + " \n" +
				"Totale SMS  inviate: " + response.data["Totale sms inviati"] + " \n" +
				"Totale   processati: " + response.data["Totale processati"] + " \n"
			);
			dispatch({type: SEND_CSV_SUCCESS})
		})
		.catch((error) => {
			alert(JSON.stringify(error))
			dispatch({type: SEND_CSV_FAIL, error: getErrorMessage(error)})
		})
}
